"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_bootstrap_1 = require("react-bootstrap");
const accountCopy_1 = require("copy/accountCopy");
const StyledHeader_1 = require("./StyledHeader");
const StyledContent_1 = require("./StyledContent");
const StyledContainer_1 = require("./StyledContainer");
const AccountNavigation_1 = __importDefault(require("./AccountNavigation"));
const Layout = () => {
    return (react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
        react_1.default.createElement(StyledContainer_1.StyledContainer, null,
            react_1.default.createElement(StyledHeader_1.StyledHeader, null, accountCopy_1.accountCopy.title),
            react_1.default.createElement(AccountNavigation_1.default, null),
            react_1.default.createElement(StyledContent_1.StyledContent, null,
                react_1.default.createElement(react_router_dom_1.Outlet, null)))));
};
exports.Layout = Layout;
